module.exports = __webpack_public_path__ + "media/theme/collection__psn-35909555.png";